import { createContext, type ReactNode, useContext } from 'react';

export type PortfolioFiltersValue = {
  searchText: string;
  /**
   * Listing responses carry no per-listing isArchived flag, so the requested view stands in for
   * each listing's archived status.
   */
  includeArchived: boolean;
};

const defaultContextValue: PortfolioFiltersValue = {
  searchText: '',
  includeArchived: false,
};

/**
 * Holds the committed (debounced) search text and archived filter for a portfolio list page
 * (Properties, Listings) so any table under it can read them without prop drilling. The page owns
 * the values via its filters state and passes them to the provider.
 */
const PortfolioFiltersContext = createContext<PortfolioFiltersValue>(defaultContextValue);

type PortfolioFiltersProviderProps = PortfolioFiltersValue & {
  children: ReactNode;
};

export const PortfolioFiltersProvider = ({ searchText, includeArchived, children }: PortfolioFiltersProviderProps) => (
  <PortfolioFiltersContext.Provider value={{ searchText, includeArchived }}>
    {children}
  </PortfolioFiltersContext.Provider>
);

export const usePortfolioFilters = () => useContext(PortfolioFiltersContext);
